import { LicenseAvailabilityColor } from "~/shared/lib/licenseAvailability";

export type AvailabilityColor = LicenseAvailabilityColor;

export const LICENSES_TOTALS_ROW_ID = "licensesTotals";

export interface ILicenseSummaryRow {
  id: string;
  dealerId: number | null;
  organizationId: string | null;
  organizationName: string;
  inn: string;
  branchCode: string;
  dealerName: string;
  partnerName: string;
  city: string;
  region: string;
  country: string;
  federalDistrict: string;
  availabilityColor: AvailabilityColor;
  totalQuantity: number;
  assignedQuantity: number;
  usedQuantity: number;
  frozenQuantity: number;
  freeQuantity: number;
  expiredQuantity: number;
}
